import React from 'react'
import type { LessonMeta } from '../types/LessonDoc'
import CurriculumPicker from './CurriculumPicker'

// Form thông tin bài học (tiêu đề, lớp, chương, bài...).
const Field: React.FC<{ label: string; value?: string; onChange: (v: string) => void; placeholder?: string }> = ({
  label,
  value,
  onChange,
  placeholder,
}) => (
  <div>
    <label className="text-xs font-bold text-gray-500 uppercase">{label}</label>
    <input
      className="w-full p-2.5 border border-gray-200 rounded-lg text-sm outline-none focus:ring-2 focus:ring-blue-200"
      value={value || ''}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
    />
  </div>
)

const LessonMetaForm: React.FC<{ meta: LessonMeta; onChange: (patch: Partial<LessonMeta>) => void }> = ({
  meta,
  onChange,
}) => {
  return (
    <div className="space-y-3">
      <Field label="Tiêu đề bài học" value={meta.tieuDe} onChange={(v) => onChange({ tieuDe: v })} placeholder="VD: Dao động điều hoà" />
      <Field label="Mô tả ngắn" value={meta.moTa} onChange={(v) => onChange({ moTa: v })} />
      <div>
        <p className="text-xs font-bold text-gray-500 uppercase mb-1">Vị trí trong chương trình (PPCT)</p>
        <CurriculumPicker
          value={{ lop: meta.lop, chuong: meta.chuong, bai: meta.bai }}
          onChange={(patch) => onChange(patch)}
          onPickLesson={(info) => {
            // Gợi ý tiêu đề theo PPCT nếu giáo viên chưa đặt tên.
            if (!meta.tieuDe?.trim()) onChange({ tieuDe: info.ten })
          }}
        />
      </div>
      <div className="grid grid-cols-2 gap-2">
        <Field label="Thời gian" value={meta.thoiGian} onChange={(v) => onChange({ thoiGian: v })} placeholder="45 phút" />
        <Field label="Độ khó" value={meta.doKho} onChange={(v) => onChange({ doKho: v })} placeholder="Trung bình" />
      </div>
    </div>
  )
}

export default LessonMetaForm
